import React from 'react'
import PropTypes from 'prop-types'
import { clipBoard } from 'Common/Utils';
import Tooltip from 'Snippets/Tooltip';
import Toast from 'Snippets/Toast';

const HoverCopy = ({children, code}) => {
    return (
        <div className="hover-board">
            <Tooltip message='copy' variant='dark'>
                <span 
                    className="hover-copy n-bg" 
                    onClick={() => {
                        clipBoard(code)
                        Toast.create(<><i className="mytabworks icon-copy"/> Copied!</>)
                    }}>
                        <i className="mytabworks icon-copy"/>
                </span> 
            </Tooltip>
            {children}
        </div>
    )
}

HoverCopy.propType = { 
    code: PropTypes.string,
    children: PropTypes.element
}

export default HoverCopy;